/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Document'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('document'); // main translation loaded for document
		$translatePartialLoader.addPart('documenttype'); // one to many reference from main entity
		$translatePartialLoader.addPart('car'); // one to many reference from main entity
		$translatePartialLoader.addPart('location'); // one to many reference from main entity
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('event'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/document/document-dialog.html';

		return {
			/* new state for entity document */
			/* to access: ui-ref="document.list.new" */
			/* url: hostname/document/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'DocumentDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'DocumentFactory',
									'NewDocumentFactory',
									function(DocumentFactory, NewDocumentFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Document
										// - resuming the creation of a new new Document AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return DocumentFactory.get({ id: $stateParams.documentId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewDocumentFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for document new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for document edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('document', {
		/* abstract state for entity document */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/document',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Documents',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('document.list', {
		/* list state for entity document */
		/* to access: ui-ref="document.list" */
		/* url: hostname/document/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/document/documents.html',
				controller: 'DocumentController',
			},
		},
	});

	$stateProvider.state('document.detail', {
		/* detail state for entity document */
		/* to access: ui-sref="document.detail" */
		/* url: hostname/document/detail/:documentId */
		url: '/detail/:documentId',
		views: {
			'content@': {
				templateUrl: 'app/entities/document/document-detail.html',
				controller: 'DocumentDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'DocumentFactory',
				function($stateParams, DocumentFactory) {
					return DocumentFactory.get({ id: $stateParams.documentId });
				},
			],
		},
	});

	/* url: http://<hostname>/document/list/new */
	$stateProvider.state('document.list.new', getNewState());
	/* url: http://<hostname>/document/list/:documentId/edit */
	$stateProvider.state('document.list.edit', getEditState('/:documentId/edit'));
	/* url: http://<hostname>/document/detail/:documentId/edit */
	$stateProvider.state('document.detail.edit', getEditState('/edit'));
	// Relation.document with multiplicity 0..n points to Document
	/* url: http://<hostname>/relation/detail/:relationId/document/new */
	$stateProvider.state('relation.detail.newDocument', getNewState('/document/new'));
	/* url: http://<hostname>/relation/detail/:relationId/document/:documentId/edit */
	$stateProvider.state('relation.detail.editDocument', getEditState('/document/:documentId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/document/new */
	$stateProvider.state('user-relation.detail.newDocument', getNewState('/document/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/document/:documentId/edit */
	$stateProvider.state('user-relation.detail.editDocument', getEditState('/document/:documentId/edit'));
	// Car.document with multiplicity 0..n points to Document
	/* url: http://<hostname>/car/detail/:carId/document/new */
	$stateProvider.state('car.detail.newDocument', getNewState('/document/new'));
	/* url: http://<hostname>/car/detail/:carId/document/:documentId/edit */
	$stateProvider.state('car.detail.editDocument', getEditState('/document/:documentId/edit'));
	// Location.document with multiplicity 0..n points to Document
	/* url: http://<hostname>/location/detail/:locationId/document/new */
	$stateProvider.state('location.detail.newDocument', getNewState('/document/new'));
	/* url: http://<hostname>/location/detail/:locationId/document/:documentId/edit */
	$stateProvider.state('location.detail.editDocument', getEditState('/document/:documentId/edit'));
	// Event.document with multiplicity 0..n points to Document
	/* url: http://<hostname>/event/detail/:eventId/document/new */
	$stateProvider.state('event.detail.newDocument', getNewState('/document/new'));
	/* url: http://<hostname>/event/detail/:eventId/document/:documentId/edit */
	$stateProvider.state('event.detail.editDocument', getEditState('/document/:documentId/edit'));

	$stateProvider.state('event.detail.subscriptions.newDocument', getNewState('/document/new'));
	$stateProvider.state('event.detail.subscriptions.editDocument', getEditState('/document/:documentId/edit'));
});
